
define('text!views/transfer/transfer_to_option.html',[],function () { return '\r\n<a href="#"><%- this.account_content %></a>';});

